import { Image, ImageEntity } from "@shapeable/types";


export const userMenuConversationsThumbnail: ImageEntity = {
  image: {
    id: 'future-council-conversations-thumbnail',
    url: 'https://res.cloudinary.com/shapeable/image/upload/v1761782807/future-council/page/conversations_thumbnail__FC_Chat_Pic_copy_rjqraq.webp',
  },
};